module.exports = __webpack_public_path__ + "img/logo_invert.9d97bdd4.svg";